<!----
    Author: hjlee
    Description:
        회원가입 모달
---->
<template>
  <!-- Modal Component -->
  <b-modal
    id="modal"
    ref="modalRef"
    size="lg"
    :title="$t('sign_up_modal.title.sign_up')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    :ok-disabled="!contentsInModalValidated('signUpModal')"
    :no-close-on-backdrop="true"
    @ok="confirm"
  >
    <input-control
      ref="signUpModal_userId"
      v-model="user.userId"
      :modal-name="modalName"
      name="user_id"
      type="email"
      required
    />
    <input-control
      ref="signUpModal_userPwd"
      v-model="user.userPwd"
      :modal-name="modalName"
      name="user_pwd"
      type="password"
      rules="password"
      required
    />
    <input-control
      ref="signUpModal_userPwdConfirm"
      v-model="user.userPwdConfirm"
      :modal-name="modalName"
      name="user_pwd_confirm"
      type="password"
      :rules="'password_confirm:' + user.userPwd"
      required
    />
    <input-control
      ref="signUpModal_nm"
      v-model="user.nm"
      :modal-name="modalName"
      name="nm"
      type="text"
      required
    />
    <input-control
      ref="signUpModal_mobile"
      v-model="user.mobile"
      :modal-name="modalName"
      name="mobile"
      type="tel"
      rules="telno"
      required
    />
  </b-modal>
</template>

<script>
export default {
  data: function() {
    return {
      user: {
        userId: '',
        userPwd: '',
        userPwdConfirm: '',
        nm: '',
        mobile: '',
        siteId: process.env.siteId
      },
      modalName: 'sign_up_modal'
    }
  },
  methods: {
    confirm: function(evt) {
      evt.preventDefault()
      this.$axios.$post('/auth/public/signUp', this.user).then(response => {
        if (response.resultCode === 'success') {
          this.$toast.info(this.$t(response.message, response.params))
          this.user = {
            userId: '',
            userPwd: '',
            userPwdConfirm: '',
            nm: '',
            mobile: '',
            siteId: process.env.siteId
          }
          this.hideModal('modalRef')
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    }
  }
}
</script>
